import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { notifyMobileOtpPost } from '../../../../api-client/api-gqnotification-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const postNotifyCustomerMobileOtp = createAsyncThunk(
    'postNotifyCustomerMobileOtp/Post',
    async (body, { rejectWithValue }) => {
        try {
            const response = await notifyMobileOtpPost(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'POST_GQ_NOTIFY_CUSTOMER_MOBILE_OTP_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const postNotifyCustomerMobileOtpSlice = createSlice({
    name: 'postNotifyCustomerMobileOtp',
    initialState,
    extraReducers: {
        [postNotifyCustomerMobileOtp.pending]: (state) => {
            state.loading = true;
        },
        [postNotifyCustomerMobileOtp.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [postNotifyCustomerMobileOtp.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const postNotifyCustomerMobileOtpSelector = (state) => state.postNotifyCustomerMobileOtp;
export const postNotifyCustomerMobileOtpReducer = postNotifyCustomerMobileOtpSlice.reducer;
